<div class="picker-trigger" (click)="toggle($event)">
  <span>{{ value || placeholder }}</span>
  <svg-icon src="assets/device/chevron-down.svg" class="picker-chevron"></svg-icon>
</div>

@if (show) {
  <div class="time-dropdown" (click)="stopPropagation($event)">
    @for (slot of timeSlots; track slot) {
      <div class="time-slot"
        [class.selected]="slot === value"
        [class.past-time]="isPastTime(slot)"
        (click)="selectTime(slot)">
        {{slot}}
      </div>
    }
  </div>
}
